<template lang="pug">
  v-dialog(v-model="show" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable max-width="700" persistent )
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    ControlDeleteSmartLinkDialog(
      v-if="showControlDeleteSmartLinkDialog"
      :show="showControlDeleteSmartLinkDialog"
      :selectedSmartLink="selectedSmartLink"
      @close="onCloseControlDialog"
      @delete="onDeleteSmartLinkClick")
    v-card.pa-0
      v-card-text.pa-0
        v-form(v-model="isFormValid" :lazy-validation="true" :disabled="saveInProgress")
          v-card.pa-0(flat)
            v-toolbar.elevation-0(v-if="selectedSmartLink")
              v-row.ma-0
                v-col.pa-0(cols="8")
                  v-card-title.pl-0() {{ $t('smartLinkPage.updateSmartLinkTitle') }}
                v-col.pa-0.text-end.pt-5(cols="4")
                  v-menu(
                  ref="updateMenu"
                  v-model="showMenu"
                  :close-on-content-click="false"
                  offset-y
                  bottom
                  left
                  )
                    template(v-slot:activator="{ on }" )
                      v-icon(color="black" small @click="onUpdateSmartLinkClick") fas fa-ellipsis-v
                    v-list
                      v-list-item(v-for="(item,idx) in items" :key="idx" @click="onItemClick(idx)")
                        v-list-item-icon
                          v-icon(:color="getColor(item)") {{item.icon}}
                        v-list-item-title {{item.title}}
            v-card-title(v-else) {{ $t('smartLinkPage.newSmartLinkTitle') }}
            v-card-text
              v-row.ma-0(v-if="selectedSmartLink")
                v-col.pa-0(cols="11")
                  v-text-field(ref="textToCopy" :label=" $t('smartLinkPage.name')" outlined dense v-model="smartLinkName" :rules="smartLinkNameRules" disabled :prefix="linkPrefix")
                v-col.pa-0.text-end(cols="1")
                  v-btn.text-center(@click="onCopyAdressClick(smartLinkUrl)" icon)
                    v-icon.text-center(medium) fa-regular fa-paste
              v-text-field(v-else :error-messages="valueNameIsRequired"  :label=" $t('smartLinkPage.name')" outlined dense v-model="smartLinkName" :rules="smartLinkNameRules" :prefix="linkPrefix" )
              v-menu(
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto")
                template(v-slot:activator="{ on }" )
                  v-text-field(outlined :label=" $t('smartLinkPage.untilFrom')" v-on="on" :value="dateRangeText" prepend-inner-icon="fal fa-calendar" readonly clearable @click:clear="onDateClearClick" clear-icon="fas fa-times" )
                v-date-picker(
                  v-model="dates"
                  first-day-of-week="1"
                  no-title
                  locale="sk"
                  range
                  @change="onRangeChange"
                  next-icon="fas fa-chevron-right"
                  prev-icon="fas fa-chevron-left"
                )
                  v-spacer
                  v-btn(@click="menu = false" color="primary") {{ $t('smartLinkPage.setDate') }}
              v-text-field(v-if="selectedSmartLink" :label=" $t('smartLinkPage.smartLinkType')" outlined dense v-model="requestKind" disabled)
              v-select(v-else :label=" $t('smartLinkPage.smartLinkType')" outlined dense v-model="requestKind"
                append-icon="fas fa-chevron-down"
                item-text="label"
                item-value="name"
                return-object
                :loading="isFetchInProgress"
                :rules="selectRules"
                :items="requestKindList"
                @change="onSelectedKindChange")

          v-divider
          v-card.pa-0.ma-0.elevation-0
            v-card-title {{ $t('smartLinkPage.settings') }}
            v-card-text.pa-0.ma-0(style="height: 42vh; overflow-y: scroll" )
              SmartLinkSettings(
                :customers="customers"
                :boarderGroupList="boarderGroupList"
                @description="getDescription"
                @selectionChange="selectionChange"
                @descriptionForBoarderGroup="descriptionForBoarderGroupChange"
                @descriptionForCustomer="descriptionForCustomerChange"
                :selectedSmartLink="selectedSmartLink")
      v-divider
      v-card-actions
        v-btn.pl-2(v-if="selectedSmartLink" text color="primary" @click="onPrintButtonClick" :disabled="saveInProgress")
          v-icon.mr-2(small) fas fa-file-pdf
          span {{ $t('smartLinkPage.printLabel') }}
        v-spacer
        v-btn.pr-2(text @click="onCloseButtonClick" :disabled="saveInProgress") {{ $t('buttons.closeButtonLabel') }}
        v-btn.pr-2(v-if="selectedSmartLink" color="primary" @click="onConfirmButtonClick" :loading="saveInProgress" :disabled="!isFormValid || isSaveButtonDisabled") {{ $t('smartLinkPage.updateButtonLabel') }}
        v-btn.pr-2(v-else color="primary" @click="onConfirmButtonClick" :loading="saveInProgress" :disabled="!isFormValid || isSaveButtonDisabled") {{ $t('smartLinkPage.createButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import SmartLink from "@/model/SmartLink";
import SmartLinkSettings from "@/components/SmartLinkSettings.vue";
import Customer from "@/model/customer/Customer";
import BoarderGroup from "@/model/boarder/BoarderGroup";
import moment from "moment";
import {Action} from "vuex-class";
import {
  CREATE_NEW_SMART_LINK,
  DELETE_SELECTED_SMART_LINK, FETCH_REQUEST_KIND_LIST, PRINT_SELECTED_SMART_LINK,
  UPDATE_SELECTED_SMART_LINK
} from "@/store/action-types";
import {CreateNewSmartLinkPayload, UpdateSmartLinkPayload} from "@/types/payload";
import {TranslateResult} from "vue-i18n";
import i18n from "@/i18n";
import {AxiosError} from "axios";
import ControlDeleteSmartLinkDialog from "@/components/ControlDeleteSmartLinkDialog.vue";
import RequestKindList from "@/model/RequestKindList";


function valueIsRequired (v: string): boolean | TranslateResult {
  return !!v || i18n.t('validation.valueIsRequired')
}

function nameValidate (v: string): boolean | TranslateResult {
    return /[A-Za-z0-9\t\-\_]+$/.test(v) || i18n.t('smartLinkPage.slugIsTooShort')

}

@Component({
  components: {
    SmartLinkSettings,
    ControlDeleteSmartLinkDialog
  }
})
export default class SmartLinkDetailDialog extends Vue {

  $refs!: {
    menu: Vue & { close: () => boolean },
    updateMenu: Vue & { close: () => boolean },
    textToCopy: Vue & { close: () => string },
  }

  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Object, required: false}) readonly selectedSmartLink!: SmartLink | null
  @Prop({type: Array, required: true}) readonly customers!: Customer[]
  @Prop({type: Array, required: true}) readonly boarderGroupList!: BoarderGroup[]
  //@Prop({type: Array, required: true}) readonly requestKindList!: RequestKindList[]
  @Prop({type: Array, required: true}) readonly actionKindList!: any[]
  @Action(UPDATE_SELECTED_SMART_LINK) updateSelectedSmartLink!: { (payload: UpdateSmartLinkPayload): Promise<void> }
  @Action(CREATE_NEW_SMART_LINK) createNewSmartLink!: { (payload: CreateNewSmartLinkPayload): Promise<void> }
  @Action(DELETE_SELECTED_SMART_LINK) deleteSelectedSmartLink!: { (payload: string): Promise<void> }
  @Action(PRINT_SELECTED_SMART_LINK) printSelectedSmartLink!: { (payload: string): Promise<any> }
  @Action(FETCH_REQUEST_KIND_LIST) fetchRequest!: { (): Promise<RequestKindList[]> }



  private smartLinkName: string = ''
  private requestKind: any | null = null
  private dates: any[] = []
  private date: string = ''
  private menu: boolean = false
  private saveInProgress = false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private smartLinkNameRules = [
      valueIsRequired,
      nameValidate
      ]
  private isFormValid: boolean = false
  private selectRules: Array<(v: string) => string | boolean> = [
    (v: string) => !!v || i18n.t('newBillingDialog.selectValidationText').toString()
  ]
  private selection: string[] = []
  private description: string = ''
  private infinityDates: string = ""
  private descriptionForCustomer: string = ''
  private descriptionForBoarderGroup: string = ''
  private customerSelection :string[] = []
  private boarderGroupSelection :string[] = []
  private isNameUsed: boolean = false
  private slugIsTooShort: boolean = false
  private showMenu: boolean = false
  private showControlDeleteSmartLinkDialog: boolean = false
  private pdfUrl: string = ''
  private items: any[] = [
    {id:1, title:i18n.t('smartLinkPage.printLabel'),icon: 'fas fa-file-pdf'},
    {id:2, title:i18n.t('smartLinkPage.deleteSmartLink'),icon: 'fas fa-trash'}
  ]
  private requestKindList: RequestKindList[] = []
  private isFetchInProgress: boolean = false


  @Watch('smartLinkName')
  watchSmartLinkName (newVal: string) {
    if (newVal && newVal.length >= 5) {
      this.isNameUsed = false
      this.slugIsTooShort = false
    } else {
      this.slugIsTooShort = true
    }
  }

  getColor (item: any) {
    if(item.icon === 'fas fa-file-pdf') {
      return 'grey'
    } else if(item.icon === 'fas fa-trash') {
      return 'red'
    }
  }

  get dateRangeText (): string {
      let date1: string = this.dates[0] ? moment(this.dates[0]).format('D.M.YYYY') : ''
      let date2: string = this.dates[1] ? moment(this.dates[1]).format('D.M.YYYY') : ''
      this.infinityDates = 'Neobmedzená platnosť'

    return this.dates && this.dates.length ? `${date1} ${date1 && date2 ? '-' : ''} ${date2}`  : `${this.infinityDates}`
  }

  get linkPrefix (): string {
    return `${window.location.host}/app/ln/`
  }

  get smartLinkUrl (): string {
    return `${window.location.origin}/app/ln/${this.smartLinkName}`
  }

  get isSaveButtonDisabled (): boolean {
    let customerSelectionLength: boolean = false
    if((this.customerSelection && this.customerSelection.length + this.boarderGroupSelection.length) < 2) {
      customerSelectionLength =  true
    } else {
      customerSelectionLength =  false
    }
    return customerSelectionLength
  }

  getDescription (item: string) {
    this.description = item
  }

  onRangeChange (item: string): void {
   if(item[0] && item[1] && moment(item[0]).isAfter(moment(item[1]))) {

     this.dates = [item[1],item[0]]
   } else {
     this.dates = [item[0],item[1]]
   }
  }

  onCopyAdressClick (item: string):void {
    navigator.clipboard.writeText(item)
    this.showSnackBar = true
    this.snackBarColor = 'success'
    this.snackBarMessage = this.$t('smartLinkPage.textCopy').toString()
  }

  descriptionForCustomerChange(item: string): void {
    this.descriptionForCustomer = item
  }

  descriptionForBoarderGroupChange(item: string): void {
    this.descriptionForBoarderGroup = item
  }

  get valueNameIsRequired (): string {
    return this.isNameUsed ? i18n.t('smartLinkPage.nameExisting').toString() : ''  || this.slugIsTooShort ? i18n.t('smartLinkPage.slugIsTooShort').toString() : ''
  }

  onDateClearClick (): void {
    this.dates = []
  }

  onUpdateSmartLinkClick (): void {
    this.showMenu = true
  }

  selectionChange (item: string[]) {
    this.customerSelection = []
    this.boarderGroupSelection = []
    item.forEach((i: any) => {
      if(i.includes('customer')){
        this.customerSelection.push(i)
      } else if(i.includes('/api/boarder-group/')){
        this.boarderGroupSelection.push(i)
      }
    })
  }

  onConfirmButtonClick (): void{
    if(this.selectedSmartLink) {
      this.updateSmartLinkClick()
    } else {
      this.createSmartLinkClick()
    }
  }

  onCloseButtonClick (): void{
    this.$emit('close')
  }

  onSelectedKindChange (item: any): void{
    if(item.name === 'onboarding') {
      item.name = 'Prihlásenie na stravu'
    }
  }

  onDeleteButtonClick () {
    this.showControlDeleteSmartLinkDialog = true
  }

  onCloseControlDialog () {
    this.showControlDeleteSmartLinkDialog = false
  }

  onItemClick(idx: any) {
    if(idx==0) {
      this.onPrintButtonClick()
    } else {
      this.onDeleteButtonClick()
    }
  }

  async fetchRequestList(): Promise<void> {

  }

  async onPrintButtonClick (): Promise<any> {
    let payload: string = `/api/smart-link/${this.selectedSmartLink!.id}`
    try {
      const response = await this.printSelectedSmartLink(payload)

      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement('a');

      fileLink.style.display = 'none'
      fileLink.href = fileURL;
      let filename = 'letak.pdf'
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    } catch (e) {

    }
  }

  async onDeleteSmartLinkClick (): Promise<void> {
    let payload: string = this.selectedSmartLink!.id
    try {
      await this.deleteSelectedSmartLink(payload)
      this.$emit('deleted',this.selectedSmartLink)
    } catch (e) {
      this.$emit('deleteError')
    }

  }

  async updateSmartLinkClick ():Promise<void> {
    let configuration : any[] = [
      {
        enabled_customers: this.customerSelection.length == this.customers.length ? [] : this.customerSelection,
        enabled_boarder_group: this.boarderGroupSelection.length == this.boarderGroupList.length ? [] : this.boarderGroupSelection,
        customers_label: this.descriptionForCustomer,
        boarder_group_label: this.descriptionForBoarderGroup,
        description: this.description
      }

    ]
    let payload: UpdateSmartLinkPayload | null = {
      id: this.selectedSmartLink?.id,
      activeFrom: this.dates[0] ? moment(this.dates[0]).format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
      activeUntil: this.dates[1] ? moment(this.dates[1]).format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
      configuration: configuration

    }
    this.saveInProgress = true
    try {
      const response: any = await this.updateSelectedSmartLink(payload)
      this.customerSelection = []
      this.boarderGroupSelection = []
      this.$emit('saved')
      this.saveInProgress = false
    } catch (e) {
      this.$emit('saveError', e)
    } finally {
    }
  }

  async createSmartLinkClick ():Promise<void> {
    let requestKinds: any[] = []
    if(this.requestKind && this.requestKind.name === 'Prihlásenie na stravu') {
      this.requestKind!.name = 'onboarding'
    }
    requestKinds.push(`/api/request-kind/${this.requestKind!.name}`)
    let configuration : any[] = [
      {
        enabled_customers: this.customerSelection.length == this.customers.length && this.boarderGroupSelection.length == this.boarderGroupList.length ? [] : this.customerSelection,
        enabled_boarder_group: this.customerSelection.length == this.customers.length && this.boarderGroupSelection.length == this.boarderGroupList.length ? [] : this.boarderGroupSelection,
        customers_label: this.descriptionForCustomer ? this.descriptionForCustomer : undefined,
        boarder_group_label: this.descriptionForBoarderGroup ? this.descriptionForBoarderGroup : undefined,
        description: this.description ? this.description : undefined
      }
    ]

    let payload: CreateNewSmartLinkPayload | null = {
      actionKind: `/api/smart-link-action-kind/${this.actionKindList[0].name}`,
      slug: this.smartLinkName,
      activeFrom: this.dates[0] ? moment(this.dates[0]).format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
      activeUntil: this.dates[1] ? moment(this.dates[1]).format('YYYY-MM-DDTHH:mm:ss[Z]') : null,
      requestKinds:requestKinds,
      configuration: configuration
    }
    this.saveInProgress = true
    try {
       const response: any = await this.createNewSmartLink(payload)

      this.saveInProgress = false
      this.$emit('saved')
    } catch (e) {
      const error = e as AxiosError
      if(error.response && error.response.status && error.response.status === 422 && error.response.data.violations[0].code === "23bd9dbf-6b9b-41cd-a99e-4844bcf3077f" ) {
        this.isNameUsed = true
      }else if(error.response && error.response.status && error.response.status === 422 && error.response.data.violations[0].code === "9ff3fdc4-b214-49db-8718-39c315e33d45") {
        this.slugIsTooShort = true
      } else {
        this.$emit('saveError', e as AxiosError)
      }
      this.saveInProgress = false
    }finally {
    }
  }

  async created (): Promise<void> {
    try {
      this.isFetchInProgress = true
      this.requestKindList = await this.fetchRequest()
      if(this.requestKindList && this.requestKindList[0] && this.requestKindList[0].name){
        if(!this.selectedSmartLink && this.requestKindList && this.requestKindList.length > 0 && this.requestKindList.length < 2){
          this.requestKind = this.requestKindList[0]
        }
      }
      this.isFetchInProgress = false
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()

    } finally {
    }
  }


  mounted(): void {
    if(this.selectedSmartLink){
      this.smartLinkName =this.selectedSmartLink.slug
      this.customerSelection = this.selectedSmartLink.configuration[0] && this.selectedSmartLink.configuration[0].enabled_customers ? this.selectedSmartLink.configuration[0].enabled_customers  : []
      this.boarderGroupSelection = this.selectedSmartLink.configuration[0] && this.selectedSmartLink.configuration[0].enabled_boarder_group ? this.selectedSmartLink.configuration[0].enabled_boarder_group : []
      this.descriptionForCustomer = this.selectedSmartLink.configuration[0] && this.selectedSmartLink.configuration[0].customers_label ? this.selectedSmartLink.configuration[0].customers_label : ''
      this.descriptionForBoarderGroup = this.selectedSmartLink.configuration[0] && this.selectedSmartLink.configuration[0].boarder_group_label ? this.selectedSmartLink.configuration[0].boarder_group_label : ''
      this.description = this.selectedSmartLink.configuration[0] && this.selectedSmartLink.configuration[0].description ? this.selectedSmartLink.configuration[0].description : ''
          this.requestKind = this.selectedSmartLink.requestKinds[0].name
      if(this.selectedSmartLink.requestKinds && this.selectedSmartLink.requestKinds.length > 0){
        let foundData: any | null = null
        this.selectedSmartLink.requestKinds.forEach((item: any) => {
          foundData = item.name
        })
        if(foundData && foundData === 'onboarding') {
          this.requestKind = this.$t(`smartLinkPage.${foundData}`).toString()
        }
      }

      if(this.selectedSmartLink.activeFrom !== '-infinity') {
        this.dates.push(this.selectedSmartLink.activeFrom)
      }
      if(this.selectedSmartLink.activeUntil!== 'infinity') {
        this.dates.push(this.selectedSmartLink.activeUntil)
      }else {
        this.dates = []
      }
    } else {
      this.smartLinkName = ''
    }

  }

}
</script>

<style lang="stylus" scoped>

.listItem {
  cursor pointer
}
</style>
